import Search from './Search.js';
export { default } from './Search.js';
//# sourceMappingURL=index.js.map
